import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('hi-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-temple-bg-warm rounded-2xl shadow-temple overflow-hidden hover:shadow-temple-lg transition-all duration-300 hover:-translate-y-1 border border-temple-primary/10">
      {blog.image && (
        <div className="h-48 overflow-hidden">
          <img 
            src={blog.image} 
            alt={blog.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
        </div>
      )}
      
      <div className="p-4 sm:p-6">
        <div className="flex items-center justify-between mb-3">
          <span className="inline-block bg-temple-primary/10 text-temple-primary text-xs font-bold px-3 py-1 rounded-full">
            {blog.category || 'ब्लॉग'}
          </span>
          <span className="text-xs text-temple-text-muted">
            {formatDate(blog.createdAt)}
          </span>
        </div>
        
        <h3 className="text-lg sm:text-xl font-serif font-bold text-temple-text mb-3 line-clamp-2 leading-tight">
          {blog.title}
        </h3>
        
        <p className="text-temple-text-muted text-sm leading-relaxed mb-4 line-clamp-3">
          {blog.excerpt || blog.content.substring(0, 150) + '...'}
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center text-xs text-temple-text-muted">
            <span className="mr-1">✍️</span>
            <span>{blog.author?.name || 'व्यवस्थापक'}</span>
          </div>
          
          <Link 
            to={`/blog/${blog._id}`}
            className="text-temple-primary font-bold text-sm hover:text-temple-primary-dark transition-colors duration-200 inline-flex items-center"
          >
            पूरा पढ़ें
            <span className="ml-1">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;